import { Component, OnInit, Input } from '@angular/core';
import { get } from 'lodash';
import { PageService } from 'src/app/services/page.service';

@Component({
  selector: 'app-conditional',
  templateUrl: './conditional.component.html',
  styleUrls: ['./conditional.component.scss']
})
export class ConditionalComponent implements OnInit {

  @Input() controls: Array<any> = [];
  @Input() data: any;

  @Input() config: {
    source: string,
    action?: string,
    operator?: string,
    mapping: {
      attributeKey: string
    },
    attributeValue: string,
    class?: string
  };

  condition: boolean = true;
  mappingSource;
  result;
  action: string = 'show';
  operator: string = 'matches';
  class: string = '';

  constructor(public pageService: PageService) { }


  /**
   * Initialization of conditional component
   * @author Lalitkumar Saindane
   * @task  QLIKTAG-3414
   */
  ngOnInit() {
    // if (this.config) {
    //   if (this.config.hasOwnProperty('source') && this.config.source) {
    //     const source = this.config.source;

    //     if (source === 'lv') {
    //       this.mappingSource = this.pageService.lv; //LV storage
    //     } else {
    //       this.mappingSource = source ? this.data[source] : null;
    //     }

    //   }

    //   if (this.config.hasOwnProperty('mapping') && this.config.mapping) {
    //     if (this.config.mapping.hasOwnProperty('attributeKey') && this.config.mapping.attributeKey) {
    //       this.result = get(this.mappingSource, this.config.mapping.attributeKey);
    //     }
    //   }

    //   if (this.config.hasOwnProperty('attributeValue')) {

    //     if (typeof this.result === 'boolean') {
    //       this.result = this.result.toString();
    //     }

    //     if (this.config.hasOwnProperty('operator') && this.config.operator) {
    //       this.operator = this.config.operator;
    //     }

    //     if (this.config.hasOwnProperty('action') && this.config.action) {
    //       this.action = this.config.action;
    //     }

    //     switch (this.operator) {
    //       case 'matches': this.result == this.config.attributeValue ?
    //         this.setCondition(true, this.action) : this.setCondition(false, this.action);
    //         break;
    //       case 'does_not_match': this.result != this.config.attributeValue ?
    //         this.setCondition(true, this.action) : this.setCondition(false, this.action);
    //         break;
    //     }

    //   }

    //   if (this.config.hasOwnProperty('class')) {
    //     this.class = this.config.class;
    //   }
    // }
  }

  /**
   * [set condition dependes on action]
   * @param result [ result of condition check]
   * @param action [ action will be show or hide ]
   * @author Lalitkumar Saindane
   * @task  QLIKTAG-3414
   */
  setCondition(result, action) {

    this.condition = false;

    if (result) {
      if (action === 'show') {
        this.condition = true;
      }

      if (action === 'hide') {
        this.condition = false;
      }

    }

  }

}
